import { render, staticRenderFns } from "./Type1Block.vue?vue&type=template&id=2dd770e1&scoped=true&"
import script from "./Type1Block.vue?vue&type=script&lang=js&"
export * from "./Type1Block.vue?vue&type=script&lang=js&"
import style0 from "./Type1Block.vue?vue&type=style&index=0&id=2dd770e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd770e1",
  null
  
)

export default component.exports